import { SimpleGrid } from '@mantine/core';
import { AutoBetStartButton } from './AutoBetStartButton';
import { ConfigureAutoBetButton } from './ConfigureAutoBetButton';

export const AutoBetMobileActions = () => {
  return (
    <SimpleGrid
      bg="dark.7"
      bottom={0}
      cols={2}
      data-test-id="auto-bet-actions-mobile"
      h={80}
      hiddenFrom="lg"
      left={0}
      p={16}
      pos="fixed"
      right={0}
      style={{
        zIndex: 20,
        borderTop: '2px solid var(--mantine-color-dark-5)',
      }}
    >
      <ConfigureAutoBetButton data-test-id="mobile-configure-auto-bet-button" />

      <AutoBetStartButton data-test-id="mobile-auto-bet-start-button" />
    </SimpleGrid>
  );
};
